// extracted by mini-css-extract-plugin
export default {"card":"FlowProductSet_card__l2ydZ","picture":"FlowProductSet_picture__IAZxY","footer":"FlowProductSet_footer__lK0LX"};